var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisposedHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 253,
    viewBox: "0 0 183 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.467 26.0139H129.75L117.393 14H55.6071L43.25 26.0139H0V50.0417H122.169L138.467 26.0139ZM114.02 62.0556H12.3571V206.222C12.3571 207.913 12.5391 209.564 12.885 211.158L37.0714 175.5V86.0833H97.7223L114.02 62.0556ZM135.929 91.3086L155.771 62.0556H160.643V206.222C160.643 219.438 149.521 230.25 135.929 230.25H41.6855L57.9834 206.222H135.929V91.3086ZM163.92 50.0417L173 36.6547V50.0417H163.92Z",
    fill: "#B3B3B3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 162.24,
    width: 25,
    height: 288.063,
    transform: "rotate(34.1488 162.24 0)",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisposedHistory);
export default __webpack_public_path__ + "static/media/disposed-history.b102ca35789b33bfe8d9aa4c554bb0c6.svg";
export { ForwardRef as ReactComponent };